import React, {Component} from "react";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {LookerCCComponent} from "./looker_cc/LookerCCComponent";
import {DataNodeComponent} from "./data_node/DataNodeComponent";
import {SyncConfigurationsTabs} from "./SyncConfigurationsTabs";
import {SyncConfigurationsHeader} from "./SyncConfigurationsHeader";

import {withRouterParams} from "../../utils/withRouterParams";

class AgencyConnectionsExportContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
    }

    redirectToAgencyRegisterPage() {
        this.props.history.push('/agency-register');
    }

    componentDidMount() {
        this.updateConnectionsInformation();
    }

    updateConnectionsInformation() {
        new APIClient(API_URL + 'agency/connections/').call('GET').then((data) => {
            if (data.status === 'ERROR_NO_AGENCY') {
                alert(data['error_message']);
                this.redirectToAgencyRegisterPage()
            } else if (data.status === 'OK') {
                this.setState({
                    lookerCCEnabled: data.data.looker_cc_enabled,
                    dataNodeEnabled: data.data.data_node_enabled,
                    lookerCCApiKey: data.data.looker_cc_api_key,
                    dataNodeApiKey: data.data.data_node_api_key,
                    channelsAllowed: data.data.channels_allowed,
                    loading: false
                });
            }
        })
    }

    render() {
        return (
            <section className="section-content">
                <SyncConfigurationsHeader/>
                <SyncConfigurationsTabs activeTab="-last"/>
                <div className="section-body -wider h-items" style={{paddingBottom:'0em'}}>
                    {this.renderLookerCCComponent()}
                </div>
                <div className="section-body -wider h-items" style={{paddingBottom:'0em'}}>
                    {this.renderDataNodeComponent()}
                </div>
            </section>
        )
    }

    renderLookerCCComponent() {
        return <LookerCCComponent apiKey={this.state.lookerCCApiKey}
                                  loading={this.state.loading}
                                  hasAccessToModule={this.state.lookerCCEnabled}
        />;
    }

    renderDataNodeComponent() {
        return <DataNodeComponent apiKey={this.state.dataNodeApiKey}
                                  loading={this.state.loading}
                                  hasAccessToModule={this.state.dataNodeEnabled}
        />;
    }
}

export default withRouterParams(AgencyConnectionsExportContent);
